import { P } from "ts-pattern";
import { pipe } from "fp-ts/es6/function";
import { array, nonEmptyArray, option, record } from "fp-ts";
import { GeoZoneHashElement, OperationElement } from "@context/map/fields/fieldsStore";
import { WsChangeBody } from "@api/socket/WebSocketService";
import logger from "../../../../utils/logger";

//@ts-ignore
import { Match } from "ts-pattern/dist/types/Match";
//@ts-ignore
import * as symbols from "ts-pattern/dist/internals/symbols";

export interface OperationMap extends Record<string, OperationElement> {
}

const generateOperationMap: (v: OperationElement[]) => OperationMap = (v: OperationElement[]) => {
    const operationMap: Record<string, nonEmptyArray.NonEmptyArray<OperationElement>> = nonEmptyArray.groupBy<OperationElement>((x) => String(x.operationId))(v)
    return record.map<nonEmptyArray.NonEmptyArray<OperationElement>, OperationElement>(nonEmptyArray.head)(operationMap);
}
const log = logger.getLogger("cultivation.ws.handler")
export default (geoZone: GeoZoneHashElement) => (change: Match<WsChangeBody, typeof symbols.unset>) => {
    return change.with({ cultivationInfo: { insert: P.not(P.nullish) } }, (v: { cultivationInfo: { insert: OperationElement[]; }; }) => {
        pipe(
            option.fromNullable(geoZone.operations),
            option.map<OperationMap, void>(operations =>
                array.map<OperationElement, void>(insertOperation =>
                    pipe(
                        record.lookup(String(insertOperation.operationId))(operations),
                        option.map(operation => {
                            log.debug("Append new polys to operation ", operation, insertOperation)
                            operation.coordinates = array.concat(operation.coordinates)(insertOperation.coordinates)
                            return operation
                        }),
                        option.getOrElse(() => {
                            operations[insertOperation.operationId] = insertOperation
                            return insertOperation
                        })
                    )
                )(v.cultivationInfo.insert)),
            option.getOrElse(() => {
                log.debug("Operation map is empty, inserting new poly's", v.cultivationInfo.insert)
                geoZone.operations = generateOperationMap(v.cultivationInfo.insert)
            }))
    })
        .with({ cultivationInfo: P.select({ base: P.not(P.nullish), clear: true, operationId: P.number }) }, (v: { base: OperationElement[]; }) => {
            geoZone.operations = generateOperationMap(v.base)
            log.debug("Apply base of cultivation poly's", v, geoZone.operations)
        })
        .with({ cultivationInfo: { clear: true, operationId: P.not(P.nullish) } }, (v: { cultivationInfo: { operationId: string | number; }; }) => {
            if (geoZone.operations) {
                delete geoZone.operations[v.cultivationInfo.operationId]
            }
        })
}